const all = (state) => state.app.jackpot;
export const amount = (state) => all(state).amount || 0;
export const currencyId = (state) => all(state).currencyId;
export const ready = (state) => all(state).ready;
